import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
	input: {
		minHeight: "51px",
		maxHeight: "51px",
		zIndex: 1,
		width: "200px",
	},
	inputFocus: {
		border: "none",
	},
	root: {
		"&.Mui-focused fieldset": {
			borderWidth: "1px !important",
		},
		"&:hover fieldset": {
			borderColor: "#969392 !important",
		},
	},
	optionsRoot: {
		position: "absolute",
		backgroundColor: "#fff",
		width: "200px",
		zIndex: 9,
		margin: "6px 0",
		borderTop: 0,
		boxShadow: "0 0 8px 0 rgba(0, 0, 0, 0.08)",
		borderRadius: "4px",
		"& .MuiAutocomplete-option[aria-selected=true]": {
			backgroundColor: "rgba(126, 166, 180, 0.15)",
		},
	},
	optionsDisabledSearchAssignee: {
		"& .MuiAutocomplete-option": {
			cursor: "default",
		},
	},
	avatar: {
		backgroundColor: theme.palette.primary.light,
		color: theme.palette.primary.dark,
	},
	assigneeSearchComplete: {
		maxWidth: 265,
		"& .MuiAutocomplete-inputRoot": {
			flexWrap: "nowrap",
			height: "48px",
		},
	},
}));
